import React from 'react';
import { GraduationCap, History, Repeat2, Sparkles } from 'lucide-react';
import { t } from '../i18n';
import './LearningCardProgress.css';

export default function LearningCardProgress({ count = 0, total = 8, points, grade, level, daysSince, ariaLabel }) {
  const current = Math.max(0, Math.min(total, count));
  const entries = [<span key="repeat" title={t('practiceUi.encounter.repeatLabel')}><Repeat2 size={14} aria-hidden="true" />{current}/{total}</span>];
  if (points != null) entries.push(<span key="points" title={t('interface.practice.workoutScore')}><Sparkles size={14} aria-hidden="true" />+{points} pt</span>);
  if (grade != null) entries.push(<span key="grade" title={t('interface.practice.currentGrade')}><GraduationCap size={14} aria-hidden="true" />{grade}</span>);
  if (level > 1) entries.push(<span key="level">Lv.{level}</span>);
  if (daysSince !== undefined) entries.push(<span key="days"><History size={14} aria-hidden="true" />{daysSince == null ? 'Never practiced' : daysSince === 0 ? 'Today' : `${daysSince}d ago`}</span>);
  return <div className="learning-card-progress">
    <div className="learning-repeat-progress" role="progressbar" aria-label={ariaLabel || t('interface.practice.cardProgress')} aria-valuemin={0} aria-valuemax={total} aria-valuenow={current}>
      <span style={{ transform: `scaleX(${total > 0 ? current / total : 0})` }} />
    </div>
    <div className="learning-card-caption">{entries.map((entry, index) => <React.Fragment key={entry.key}>{index > 0 && <span className="learning-caption-divider" aria-hidden="true">·</span>}{entry}</React.Fragment>)}</div>
  </div>;
}

export function RepeatActionButton({ label, stepLabel, className = '', ...props }) {
  return <button type="button" {...props} className={`learning-repeat-action ${className}`.trim()}>
    <Repeat2 size={20} strokeWidth={2.2} aria-hidden="true" />
    <span>{label}</span>
    {stepLabel && <span className="learning-repeat-step">{stepLabel}</span>}
  </button>;
}
